import { render, staticRenderFns } from "./presens-av-svaga-verb.vue?vue&type=template&id=9655bd94&scoped=true"
import script from "./presens-av-svaga-verb.vue?vue&type=script&lang=js"
export * from "./presens-av-svaga-verb.vue?vue&type=script&lang=js"
import style0 from "./presens-av-svaga-verb.vue?vue&type=style&index=0&id=9655bd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9655bd94",
  null
  
)

export default component.exports